import React from "react";
import { useFormikContext } from "formik";

import { FormColorField } from "ui/Form";
import SectionDescription from "components/SectionDescription";

import ColorIcon from "assets/svg/color.svg";

const PrimaryColorSection = () => {
  const {
    values: { mode },
  } = useFormikContext();

  return (
    <>
      <SectionDescription
        title="Primary color"
        description="Select the main color for your theme. This will be the key color used throughout the design."
        LeadIcon={ColorIcon}
      />
      <FormColorField name={`${mode}.primary`} label="Primary" />
    </>
  );
};

export default PrimaryColorSection;
